jQuery(document).ready(function($) {
  if ($('body.single-landing').length > 0) {
    var $navItems = $('header #menu-top-menu a, .mobile-menu a');
    var anchors = [];
    $.each($navItems, function() {
      anchors.push($(this).attr('href'));
    });
    $navItems.on("click", function(e) {
      e.preventDefault();
      $('.menu-logo .icon-close').trigger('click');
      var $target = $('section'+$(this).attr('href'));
      if ($target.length > 0) {
        $('html, body').animate({scrollTop: $target.offset().top - $('header').outerHeight()}, 1000);
      }
    })
  }
})
